import {DialogWrapper as Dialog} from '../../components/DialogWrapper/DialogWrapper';
import React from 'react';
import {type ConnectedProps, connect} from 'react-redux';

import {hideErrorModal} from '../../store/actions/modals/errors';
import {selectModalErrors} from '../../store/selectors/modals/errors';
import {YTErrorBlock} from '../../containers/Block/Block';
import {type RootState} from '../../store/reducers';
import {type ErrorInfo} from '../../store/reducers/modals/errors';
import i18n from './i18n';

interface MEProps {
    id: number | string;
    data: ErrorInfo;
    hide: (id: MEProps['id']) => void;
    children?: React.ReactNode;
}

export function ModalError({id, data, hide, children}: MEProps) {
    const close = React.useCallback(() => {
        hide(id);
    }, [id, hide]);

    const {error, hideOopsMsg, type, helpURL, disableLogger, defaultExpandedCount} = data;

    const isAlert = type === 'alert';

    return (
        <Dialog open={true} onClose={close}>
            <Dialog.Header caption={isAlert ? i18n('title_alert') : i18n('title_error')} />
            <Dialog.Divider />
            <Dialog.Body>
                <YTErrorBlock
                    type={isAlert ? 'alert' : 'error'}
                    message={!hideOopsMsg && i18n('alert_something-went-wrong')}
                    error={error}
                    helpURL={helpURL}
                    disableLogger={disableLogger}
                    defaultExpandedCount={defaultExpandedCount}
                />
                {children}
            </Dialog.Body>
        </Dialog>
    );
}

type Props = ConnectedProps<typeof connector>;

class ModalErrors extends React.Component<Props> {
    hideError = (errorId: number | string) => {
        this.props.hideError(errorId);
    };

    override render() {
        const {errors} = this.props;
        return errors.map(({id, error}) => {
            return <ModalError key={id} id={id} data={error} hide={this.hideError} />;
        });
    }
}

const mapStateToProps = (state: RootState) => {
    return {
        errors: selectModalErrors(state),
    };
};

const mapDispatchToProps = {
    hideError: hideErrorModal,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(ModalErrors);
